import {
  AppBar as MuiAppBar,
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { styled, useTheme } from "@mui/styles";
import { drawerWidth } from "admin/layout/AppDrawer";
import LoggedUserCard from "admin/layout/LoggedUserCard";

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  padding: theme.spacing(2, 3),
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: drawerWidth,
  width: `calc(100% - ${drawerWidth}px)`,
}));

const CustomAppBar = ({ children }) => {
  const theme = useTheme();
  const verticalSpacing = theme.spacing(5);
  return (
    <AppBar
      position={"static"}
      color={"secondary"}
      sx={{ marginTop: `-${verticalSpacing}` }}
    >
      <Container maxWidth={"xl"}>
        <Grid container justifyContent={"space-between"}>
          <Grid item>
            <Typography variant={"h6"}>Mon service social</Typography>
            <Box id={"react-admin-title"} />
          </Grid>
          <Grid item>
            <LoggedUserCard />
          </Grid>
        </Grid>
      </Container>
    </AppBar>
  );
};

export default CustomAppBar;
